import { GET_PATIENT_HEALTH_SUMMARY } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

interface Response {
    success: boolean;
    response: PatientHealthSummaryResponse;
    error?: string;
}

export interface PatientHealthSummaryResponse {
    medical_profile: MedicalProfile[];
    updates_in_last_visit: string[];
    suggested_lab_tests: SuggestedLabTest[];
    tags: Tag[];
    detail?: string;
}

interface MedicalProfile {
    heading: string;
    insight: string;
}

interface SuggestedLabTest {
    test_name: string;
    reason: string;
}

interface Tag {
    tag: string;
    color_scheme: string;
}

export default (patientId: string): Promise<Response> => {
    return fetchWithRefresh(GET_PATIENT_HEALTH_SUMMARY(patientId)).then((res) => res.json());
};
